;(function () {
    function initTranscriptMarkup() {
        var article = document.querySelector(".article--interview");

        if (!article) {
            return;
        }

        var transcriptParagraphs = article.querySelectorAll(".gh-content p");
        var hostName = null;

        transcriptParagraphs.forEach(function (paragraph) {
            var strong = paragraph.querySelector(":scope > strong");

            if (!strong) {
                return;
            }

            var label = strong.textContent.trim();

            if (!label.endsWith(":")) {
                return;
            }

            if (!hostName) {
                hostName = label;
                paragraph.classList.add("transcript-host");
                return;
            }

            paragraph.classList.add(label === hostName ? "transcript-host" : "transcript-guest");
        });
    }

    document.addEventListener("DOMContentLoaded", initTranscriptMarkup);
})();
